import { Component, Input } from '@angular/core';
import { environment } from '@environment';

import { BannerService } from '@app/core/services/banner/banner.service';

import { DeferImageLoadDirective } from '@app/shared/directives/defer-image-load.directive';

import { ImageSliderComponent } from '@app/shared/components/image-slider/image-slider.component';
import { ScrollWrapperComponent } from '@app/core/components/wrappers/scroll-wrapper/scroll-wrapper.component';
import { GradientHeadingComponent } from '@app/shared/components/gradient-heading/gradient-heading.component';
import { WhatsOnYourMindBannerComponent } from '@app/shared/components/whats-on-your-mind-banner/whats-on-your-mind-banner.component';

@Component({
    selector: 'app-home-page-banners',
    standalone: true,
    imports: [
        ScrollWrapperComponent,
        WhatsOnYourMindBannerComponent,
        DeferImageLoadDirective,
        ImageSliderComponent,
        GradientHeadingComponent
    ],
    templateUrl: './home-page-banners.component.html',
    styleUrls: ['./home-page-banners.component.scss']
})
export class HomePageBannersComponent {
    @Input() outletBanners = [];
    @Input() isMobile: boolean;
    deployUrl: string;
    constructor(private bannerService: BannerService) {
        this.deployUrl = environment.DEPLOY_URL;
    }

    openActionLink(imageData: any, index: number) {
        this.bannerService.openActionLink(imageData, index);
    }
}
